<template>
  <div class="container">

    <Loading :show="!data.length" />
    
    <button @click="sync">Ladda om</button>
    <br />

    <button @click="filterSync(key)" v-for="(v, key) in types" :class="(v.active ? 'active' : '') + ' type--' + v.severity">{{ v.emoji }} {{ v.label }}</button>

    <div style="margin-bottom: 20px;"></div>

    <table>
      <tr>
        <th>ID</th>
        <th>Typ</th>
        <th>Väg</th>
        <th>Ämne</th>
        <th>Meddelande/fel</th>
        <th>Skapad</th>
      </tr>

      <tbody v-for="n in data" @click="n.expanded = true" :class="(n.expanded ? 'expanded ' : '')">
        <tr>
          <td>#{{ n.id }}</td>
          <td :class="'type--' + n.severity">{{ n.emoji }} {{ n.label }}</td>
          <td>{{ JSON.parse(n.context).other.PATH_INFO || JSON.parse(n.context).other.laravel_path }}</td>
          <td>{{ JSON.parse(n.exception).subject }}</td>
          <td v-html="JSON.parse(n.exception).msg || JSON.parse(n.exception).error"></td>
          <td>{{ n.created_at }}</td>
        </tr>

        <tr v-if="n.expanded">
          <th colspan="3">Kontext</th>
          <th colspan="3">Felväg</th>
        </tr>

        <tr v-if="n.expanded">
          <td colspan="3">
            <table>
              <tr v-for="(a, b) in JSON.parse(n.context)" v-if="n.context && b !== 'other'">
                <th>{{ b }}:</th><td>{{ a }}</td>
              </tr>
              <tr v-for="(a, b) in JSON.parse(n.context).other" v-if="n.context">
                <th>{{ b }}:</th><td>{{ a }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <button class="btn white border small" @click.stop="n.expanded = false">Stäng</button>
                </td>
              </tr>
            </table>
          </td>
          <td colspan="3" v-html="'<pre>' + (JSON.parse(n.exception).trace || '').replace(/\n/g, '<br>') + '</pre>'"></td>
        </tr>

      </tbody>

    </table>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      data: [],
      types: {},
    };
  },
  mounted() {
    this.sync();
  },
  computed: {
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    async sync() {
      const ids = Object.values(this.types).filter(n => n.active).map(n => n.key);
      const types = ids.join(',');

      const { data, meta } = await API.get(`notifications?types=${types}`);
      this.data = data;

      if (Object.keys(this.types).length === 0) {
        this.types = meta.levels;
      }
    },
    async filterSync(index) {
      this.types[index].active = !this.types[index].active; // eslint-disable-line
      await this.sync();
    },
  },
  filters: {
    nl2br(value) {
      return value.replace('\n', '<br>');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.container
  margin-top 50px

button
  border: 0 !important
  &.active
    border: 2px solid black !important

tbody
  cursor pointer
  border-bottom 2px solid white
  background-color #f5f5f5
  tr:nth-child(3)
    td:first-child
      padding-left: 10px
    td
      text-align: left
      vertical-align top
  &.expanded
    background-color #eeeeee

.type--2
  background-color red
  color white
.type--3
  background-color yellow
  color #333333
.type--5
  background-color lightyellow
  color #333333
.type--9
  background-color inherit
  color #333333

table
  width 100%
  th
    text-align left
    padding-right 10px
  td
    padding-right 15px
    padding-bottom 5px
    &:first-child
      text-align center
      padding-left 7px
      padding-right 7px
</style>



// WEBPACK FOOTER //
// Notifications.vue?76e4b3d4